import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutor-expertise-card',
  templateUrl: './tutor-expertise-card.component.html',
  styleUrls: ['./tutor-expertise-card.component.css']
})
export class TutorExpertiseCardComponent implements OnInit {

  @Input() expertiseData: any = null;

  @Input() dataType: any = null;

  constructor() { }

  ngOnInit(): void {
  }

}
